import React from "react";
// @ts-ignore
import { IconButton } from "@hopper/icon_button";

type ToggleIconProps = {
  toggleSideBar: () => void;
};

const ToggleIcon = ({ toggleSideBar }: ToggleIconProps) => (
  <div
    className="visible-xs visible-sm absolute text-4xl leading-125"
    style={{ top: -4, right: 5 }}
    data-testid="nav-close-button"
  >
    <IconButton
      onClick={toggleSideBar}
      aria-label="Close"
      appearance="ghost"
      variant="secondary"
      style={{ color: "white" }}
    >
      &times;
    </IconButton>
  </div>
);

export default ToggleIcon;
